export default __webpack_public_path__ + "static/media/postgresql.6174db8b.svg";